/* ============================================================
   MaxStudios — portfolio gallery fix (collection templates)
   Finds photo blocks (image-background groups that contain only
   a spacer), removes their crop, and adds a fullscreen lightbox.
   Added by Claude.
   ============================================================ */
(function () {
  "use strict";

  function biggestSrc(img) {
    var ss = img.getAttribute("srcset");
    if (ss) {
      var best = null, bw = 0;
      ss.split(",").forEach(function (cand) {
        var parts = cand.trim().split(/\s+/);
        var w = parseInt((parts[1] || "").replace("w", ""), 10) || 0;
        if (parts[0] && w >= bw) { bw = w; best = parts[0]; }
      });
      if (best) return best;
    }
    var src = img.currentSrc || img.src || "";
    if (/([?&])width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, "$1width=2600");
    return src;
  }

  var groups = [];
  document.querySelectorAll("#MainContent .group-block").forEach(function (group) {
    var img = group.querySelector(":scope > .group-block__media-wrapper .background-image-container img");
    if (!img) return;
    // Only pure photo blocks: no text, no links/buttons inside
    if (group.textContent.trim() !== "") return;
    if (group.querySelector("a, button")) return;
    if (!group.querySelector(".spacer-block")) return;

    function applyRatio() {
      if (img.naturalWidth && img.naturalHeight) {
        group.style.setProperty("--ms-ratio", img.naturalWidth + " / " + img.naturalHeight);
      }
    }
    if (img.complete) applyRatio();
    else img.addEventListener("load", applyRatio);

    group.classList.add("ms-zoomable");
    group.setAttribute("role", "button");
    group.setAttribute("tabindex", "0");
    group.setAttribute("aria-label", "View photo full screen");
    var section = group.closest(".shopify-section");
    if (section) section.classList.add("ms-gallery-section");
    groups.push({ group: group, img: img });
  });

  if (!groups.length) return;

  /* --- justified rows: equal height for photos sharing a row --- */
  var rows = new Map();
  groups.forEach(function (g) {
    var parent = g.group.parentElement;
    if (!rows.has(parent)) rows.set(parent, []);
    rows.get(parent).push(g);
  });
  rows.forEach(function (list, parent) {
    function computeRow() {
      var ratios = list.map(function (g) {
        return g.img.naturalWidth && g.img.naturalHeight ? g.img.naturalWidth / g.img.naturalHeight : 0;
      });
      if (ratios.some(function (r) { return !r; })) return;
      var sum = ratios.reduce(function (a, b) { return a + b; }, 0);
      var gap = parseFloat(getComputedStyle(parent).columnGap) || 0;
      var gaps = gap * (list.length - 1);
      parent.classList.add("ms-row-justified");
      list.forEach(function (g, i) {
        g.group.style.setProperty("--ms-share", (ratios[i] / sum).toFixed(4));
        g.group.style.setProperty("--ms-gaps", gaps + "px");
        g.group.style.setProperty("--ms-r", ratios[i].toFixed(4));
        if (list.length === 1) g.group.classList.add("ms-solo");
      });
    }
    list.forEach(function (g) {
      if (!g.img.complete) g.img.addEventListener("load", computeRow);
    });
    computeRow();
  });


  var lb = document.createElement("div");
  lb.className = "ms-lightbox";
  lb.setAttribute("role", "dialog");
  lb.setAttribute("aria-label", "Photo viewer");
  lb.innerHTML =
    '<img alt="Full size photo">' +
    '<button type="button" class="ms-lb-close" aria-label="Close">✕</button>' +
    '<button type="button" class="ms-lb-prev" aria-label="Previous photo">←</button>' +
    '<button type="button" class="ms-lb-next" aria-label="Next photo">→</button>' +
    '<span class="ms-lb-count"></span>';
  document.body.appendChild(lb);

  var lbImg = lb.querySelector("img");
  var lbCount = lb.querySelector(".ms-lb-count");
  var idx = 0;

  function show(i) {
    idx = (i + groups.length) % groups.length;
    lbImg.src = biggestSrc(groups[idx].img);
    lbCount.textContent = (idx + 1) + " / " + groups.length;
    [idx + 1, idx - 1].forEach(function (n) {
      var m = (n + groups.length) % groups.length;
      new Image().src = biggestSrc(groups[m].img);
    });
  }
  function openLb(i) {
    show(i);
    lb.classList.add("is-open");
    document.documentElement.style.overflow = "hidden";
  }
  function closeLb() {
    lb.classList.remove("is-open");
    document.documentElement.style.overflow = "";
  }

  groups.forEach(function (g, i) {
    g.group.addEventListener("click", function (e) {
      e.preventDefault();
      openLb(i);
    });
    g.group.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openLb(i); }
    });
  });
  lb.querySelector(".ms-lb-close").addEventListener("click", closeLb);
  lb.querySelector(".ms-lb-prev").addEventListener("click", function (e) { e.stopPropagation(); show(idx - 1); });
  lb.querySelector(".ms-lb-next").addEventListener("click", function (e) { e.stopPropagation(); show(idx + 1); });
  lb.addEventListener("click", function (e) { if (e.target === lb) closeLb(); });
  document.addEventListener("keydown", function (e) {
    if (!lb.classList.contains("is-open")) return;
    if (e.key === "Escape") closeLb();
    if (e.key === "ArrowLeft") show(idx - 1);
    if (e.key === "ArrowRight") show(idx + 1);
  });
  var touchX = null;
  lb.addEventListener("touchstart", function (e) { touchX = e.touches[0].clientX; }, { passive: true });
  lb.addEventListener("touchend", function (e) {
    if (touchX === null) return;
    var dx = e.changedTouches[0].clientX - touchX;
    if (Math.abs(dx) > 48) show(dx > 0 ? idx - 1 : idx + 1);
    touchX = null;
  }, { passive: true });
})();
